import { render, staticRenderFns } from "./ConfigWebsiteCatalogueProductMerch.vue?vue&type=template&id=7ea23456&scoped=true"
import script from "./ConfigWebsiteCatalogueProductMerch.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueProductMerch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea23456",
  null
  
)

export default component.exports